// Groups Tickets (`/group-purchases`) stays out while that menu item is commented out.

const PACKAGE_MENU_LINKS = [
  { to: '/assign-inventory', label: 'Assign Inventory' },
  { to: '/flex-packages', label: 'Flex Packages' },
  { to: '/season-packages', label: 'Season Packages' },
]

const EVENT_MENU_PATHS = [
  '/event/:uuid',
  '/event/:uuid/event-details',
  '/event/:uuid/event-settings',
  '/event/:uuid/seatmap',
  '/event/:uuid/offers',
  '/event/:uuid/assign-tickets',
  '/event/:uuid/resale-tickets',
  '/event/:uuid/waitlist',
  '/event/:uuid/tracking-links',
  '/event/:uuid/purchaser-export',
]

const PACKAGE_PAGE_PATHS = [
  '/package/:uuid',
  '/package/:uuid/package-details',
  '/package/:uuid/seatmap',
  '/package/:uuid/assign-packages',
  '/package/:uuid/package-holders',
]

const FLEX_PACKAGE_PAGE_PATHS = [
  '/flex-package/:uuid',
  '/flex-package/:uuid/flex-package-details',
  '/flex-package/:uuid/assign-flex-packages',
  '/flex-package/:uuid/flex-package-holders',
]

const CREATE_MENU_PATHS = ['/events/create', '/access-passes']

const MARKETING_MENU_PATHS = ['/fundraisers', '/promo-codes', '/promo-emails']

const PROFILE_MENU_PATHS = [
  '/settings',
  '/settings/organization-information',
  '/settings/organization-settings',
  '/settings/email-templates',
  '/settings/marketing-attribution',
  '/settings/team-management',
  '/settings/security',
  '/settings/terminals',
  '/settings/scanners',
  '/settings/custom-fees',
  '/settings/buyer-types',
  '/settings/marketplace',
  '/settings/donations',
]

const ANALYTICS_PATH = '/analytics'

export {
  ANALYTICS_PATH,
  CREATE_MENU_PATHS,
  EVENT_MENU_PATHS,
  FLEX_PACKAGE_PAGE_PATHS,
  MARKETING_MENU_PATHS,
  PACKAGE_MENU_LINKS,
  PACKAGE_PAGE_PATHS,
  PROFILE_MENU_PATHS,
}
